import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import palette from '../../../styles/palette';

export default function MarketInfo({ marketTitle, zipCount }) {
  const styles = {
    panel: {
      padding: '1em',
      marginLeft: '1em',
      backgroundColor: palette.white,
      border: `1px solid ${palette.soft_blue}`,
      borderRadius: '8px',
    },
  };

  const renderCell = (label, value) => (
    <Stack direction="row" spacing={1}>
      <Typography variant="body2">{label}:</Typography>
      <Typography variant="body2" sx={{ fontWeight: '600' }}>
        {value}
      </Typography>
    </Stack>
  );

  return (
    <Stack direction="column" sx={styles.panel}>
      {renderCell('Market', marketTitle)}
      {renderCell('Zips', zipCount)}
    </Stack>
  );
}
